import { Row, Col } from 'react-bootstrap';
import { useContext, useState, useEffect, useRef } from 'react';
import Card from '../../ui/Card';
import CurrentAdtrAuthorizations from '../adminCommon/adtrAuthorizationCurrent';
import NewAdtrAuthorizations from '../adminCommon/adtrAuthorizationNew';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import SecurityContainer from '../securityContainer';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { useParams } from "react-router-dom";
import AdminService from "../../../services/AdminService";

const ADTRAuthorizationdAdd = (props) => {
  const user = useContext(UserContext);
  const params= useParams();
  const pageType = params.pageType;
  const currentAdtrAuthorizationRef = useRef(null);
  const newAdtrAuthorizationRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [cdiacNumbers, setCdiacNumbers] = useState([]);
  const [finalSaleId, setFinalSaleId] = useState("");
  const [addAuthorizatiomError, setAddAuthorizationError] = useState("");
  const [adtrAuthorizations, setAdtrAuthorizations] = useState([]); //Existing adtr authorizations in ADTR Authorization table
  const [newAdtrAuthorizations, setNewAdtrAuthorizations] = useState([]); //New adtr authorizations in Review table
  const [cdiacNumber, setCdiacNumber] = useState("");
  const reviewHistory = {
    "proposeDebtId": null,
    "finalSaleId": null,
    "updateType" : "Authorization",
    "reviewStatusFlag": "",                        
    "createUser": CommonService.getUserName(user)                        
  }

  const handleCdiacChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    const selectedCdiacNumber = e.length > 0 ? e[0]['cdiacNumber'] : '';
    setFinalSaleId(checkValue);
    setCdiacNumber(selectedCdiacNumber);
    if (checkValue) {
      setAddAuthorizationError('');
    }
  }


  const handleAddAuthorizationBtn = (e) => {
    if (finalSaleId === '') {
      setAddAuthorizationError('Please select CDIAC number');
      return;
    }
    if (!adtrAuthorizations || adtrAuthorizations.length === 0) {
      setAddAuthorizationError('Selected Report of Final Sale does not have any ADTR Authorizations to update');
      return;
    }

    setAddAuthorizationError('');

    //Call backend code to bulk create the new authorizations
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addAdtrAuthorizations",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adtrAuth": {"adtrId": 0,
                            "authorizationId": 0,
                            "beginAmt" : 0.00,
                            "lapsedAmt": 0.00,
                            "duringAmt": 0.00,
                            "authorityReplenishAmt": 0.00,
                            "authorityReducedAmt": 0.00,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user)
                },
                "finalSaleId" : finalSaleId,
                "updateType" : "Authorization"
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("ADTR Authorizations added successfully!");
                    //Also call the backend to get the newly created authorizations
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  const handleCancelAuthorizationBtn = (e) => {
    if (finalSaleId === '') {
      setAddAuthorizationError('Please select CDIAC number');
      return;
    }
    if (!newAdtrAuthorizations || newAdtrAuthorizations.length === 0) {
      setAddAuthorizationError('Selected Report of Final Sale does not have any New ADTR Authorizations to cancel');
      return;
    }

    setAddAuthorizationError('');

    //Call backend code to delete the rejected new authorizations from the review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectAdtrAuthorizationsReview",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adtrAuths": newAdtrAuthorizations
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Cancellation of ADTR Authorizations was successful!");
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  const handleApproveAuthorizationBtn = (e) => {
    if (finalSaleId === '') {
      setAddAuthorizationError('Please select CDIAC number');
      return;
    }
    if (!newAdtrAuthorizations || newAdtrAuthorizations.length === 0) {
      setAddAuthorizationError('Selected Report of Final Sale does not have any New ADTR Authorizations to approve');
      return;
    }

    setAddAuthorizationError('');

    //Call backend code to save the new approved authorizations in Adtr Authorization table and delete them from the review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "approveAdtrAuthorizationsReview",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "newAdtrAuths": newAdtrAuthorizations,
                 "currentAdtrAuths": adtrAuthorizations
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Approval of ADTR Authorizations was successful!");
                    //Create Review History data
                    reviewHistory.finalSaleId = finalSaleId;
                    reviewHistory.reviewStatusFlag = "A";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to get the newly created authorizations
                    currentAdtrAuthorizationRef.current.getAuthorizationsByRFSId(finalSaleId);
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }

  const handleRejectAuthorizationBtn = (e) => {
    if (finalSaleId === '') {
      setAddAuthorizationError('Please select CDIAC number');
      return;
    }
    if (!newAdtrAuthorizations || newAdtrAuthorizations.length === 0) {
      setAddAuthorizationError('Selected Report of Final Sale does not have any New ADTR Authorizations to reject');
      return;
    }

    setAddAuthorizationError('');

    //Call backend code to delete the rejected new authorizations from the review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectAdtrAuthorizationsReview",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adtrAuths": newAdtrAuthorizations
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Rejection of ADTR Authorizations was successful!");
                    //Create Review History data
                    reviewHistory.finalSaleId = finalSaleId;
                    reviewHistory.reviewStatusFlag = "R";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to get the newly created authorizations
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  useEffect(() => {
    getCdiacNumbers();
  }, []);


  const getCdiacNumbers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getCdiacFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "updateType": "FinalSale"
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacNumbers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  return (
    <SecurityContainer>
      <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="container">
                <div id="packet_id" className="panel-title">
                  {pageType === "Add" && <h1 className="menu-title">ADTR Authorization Addition</h1>}
                  {pageType === "Review" && <h1 className="menu-title">ADTR Authorization Review</h1>}
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div className="container">
                <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                        <label>CDIAC Number: </label>
                        <Typeahead
                          placeholder="Choose CDIAC Number"
                          id="finalsale"
                          labelKey="cdiacNumber"
                          onChange={e => handleCdiacChange(e, "finalSaleId")}
                          inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                          options={cdiacNumbers}
                          sort
                        />
                      </div>

                    </Col>
                  </Row>

                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div>
                        <a href="/admin" className="dk-blue-color link-button" style={{ float: 'left' }}>Back to Admin</a>
                      </div>
                       <div className="fleft w-50" style={{ float: 'right' }}>
                        {pageType === "Add" && <button className="custom-button bg-success text-light rounded" style={{ float: 'left' }} onClick={handleCancelAuthorizationBtn} >
                          Cancel All Changes
                        </button>}
                        {pageType === "Add" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddAuthorizationBtn} >
                          Add New Authorization
                        </button>}
                      </div>
                      <div className="fleft w-50" style={{ float: 'right' }}>
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'left' }} onClick={handleApproveAuthorizationBtn} >
                          Approve
                        </button>}
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleRejectAuthorizationBtn} >
                          Reject
                        </button>}
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className="error"> {addAuthorizatiomError}</p>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <CurrentAdtrAuthorizations
                      onDataFetch={setAdtrAuthorizations}
                      reportId={finalSaleId}
                      ref={currentAdtrAuthorizationRef}
                    />
                  </div>
                  <hr />
                  <div>
                    <NewAdtrAuthorizations
                      cdiacNumber={cdiacNumber}
                      onDataFetch={setNewAdtrAuthorizations}
                      reportId={finalSaleId}
                      updateType="Authorization"
                      ref={newAdtrAuthorizationRef}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </form>
    </SecurityContainer>

  )
}

export default ADTRAuthorizationdAdd
